/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/microphone_medium'
export default icon
